import { Pipe, PipeTransform } from '@angular/core';
import { Assignment } from '../../backend/model';

@Pipe({
  name: 'userChoiceSort'
})
export class UserChoiceSortPipe implements PipeTransform {
  transform(value: any[], valOrderBy?: string, valReverse?: boolean): Assignment[] {
    let orderBy = 'employeeHsaId';
    let reverse = false;

    if (valOrderBy) {
      orderBy = valOrderBy;
    }

    if (valReverse !== undefined) {
      reverse = valReverse;
    }

    value.sort((a, b) => {
      if (a[orderBy] === b[orderBy]) {
        return 0;
      }

      if (reverse) {
        if (a[orderBy] < b[orderBy]) {
          return 1;
        } else {
          return -1;
        }
      } else {
        if (a[orderBy] < b[orderBy]) {
          return -1;
        } else {
          return 1;
        }
      }
    });

    return value;
  }
}
